import { ReactElement, useEffect, useState } from "react";
import { ReactSVG } from "react-svg";
import { ColumnsType } from "antd/es/table";

import "./roles-list.scss";
import { Tooltip } from "antd";
import CustomTable from "../../../../components/custom-table/custom-table";
import CustomSearch from "../../../../components/custom-search/custom-search";
import CustomModal from "../../../../components/custom-modal/custom-modal";
import { Link } from "react-router-dom";
import AddEditRole from "../add-edit-role/add-edit-role";
import ViewRole from "../view-role/view-role";
import DeleteModal from "../../../../components/delete-modal/delete-modal";
import { useDispatch, useSelector } from "react-redux";
import { LOADING } from "../../../../store/actions";
import instance from "../../../../store/axios";
import { AxiosResponse } from "axios";
import { toast } from "react-hot-toast";

const RolesList: React.FC = (): ReactElement => {
  const dispatch = useDispatch();
  const loadingState = useSelector((state: any) => state?.loading);
  const [rolesData, setRolesData] = useState([]);
  const [openEditRoleModal, setOpenEditRoleModal] = useState(false);
  const [openViewModal, setOpenViewModal] = useState(false);
  const [openDeleteModal, setOpenDeleteModal] = useState(false);
  const [openNotDeleteModal, setOpenNotDeleteModal] = useState(false);
  const [selectedRole, setSelectedRole] = useState<any>();

  useEffect(() => {
    getRolesData();
  }, []);

  const getRolesData = async (): Promise<void> => {
    dispatch({ type: LOADING, payload: true });

    try {
      const response: AxiosResponse<any> = await instance.get(`/${process.env.REACT_APP_ENDPOINT_VERSION}/role`);
      setRolesData(response.data.data);
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", `/backend-users`);
    }

    dispatch({ type: LOADING, payload: false });
  };

  const deleteRole = async (): Promise<void> => {
    dispatch({ type: LOADING, payload: true });

    try {
      await instance.delete(`/${process.env.REACT_APP_ENDPOINT_VERSION}/role/${selectedRole.id}`);
      toast.success("Role deleted successfully");
      getRolesData();
      setOpenDeleteModal(false);
    } catch (error: any) {
      if (error?.response?.status !== 401) {
        toast.error(error?.response?.data?.message || "An error occurred");
      }
      localStorage.setItem("star_prev_url", `/backend-users`);
    }

    dispatch({ type: LOADING, payload: false });
  };

  const columns: ColumnsType<any> = [
    {
      title: "#",
      dataIndex: "id",
      key: "id",
    },
    {
      title: "Role name",
      dataIndex: "role",
      key: "role",
      sorter: (a, b) => String(a?.role).localeCompare(String(b?.role)),
      fixed: "left",
      width: 200,
      render: (text, record) => (
        <Link
          to=""
          onClick={() => {
            setSelectedRole(record);
            setOpenViewModal(true);
          }}
        >
          {text}
        </Link>
      ),
    },
    {
      title: "Description",
      dataIndex: "description",
      key: "description",
      width: 300,
      sorter: (a, b) =>
        String(a?.description).localeCompare(String(b?.description)),
    },
    {
      title: "Assigned users",
      dataIndex: "admins",
      key: "admins",
      render: (_, record) => (
        <span>{record.admins?.map((user: any) => user.name)?.join(", ")}</span>
      ),
    },
    {
      title: "Actions",
      key: "actions",
      render: (_, record) => (
        <div className="actions flex align-center">
          <ReactSVG
            src={"/images/edit.svg"}
            onClick={() => {
              setSelectedRole(record);
              setOpenEditRoleModal(true);
            }}
          />
          <ReactSVG
            className="delete-icon"
            src={"/images/delete.svg"}
            onClick={() => {
              setSelectedRole(record);
              if (record.admins?.length) {
                setOpenNotDeleteModal(true);
              } else {
                setOpenDeleteModal(true);
              }
            }}
          />
        </div>
      ),
    },
  ];

  return (
    <div className="roles-table">
      <div className="title flex align-center justify-space-between">
        <p>{!loadingState ? rolesData?.length : ""} Roles</p>
        <div className="images flex align-center">
          {/* <CustomSearch />
          <Tooltip placement="topLeft" title="Columns settings">
            <img src="/images/grid.svg" alt="grid" />
          </Tooltip>
          <Tooltip placement="topLeft" title="Export">
            <img src="/images/export.svg" alt="export-customers" />
          </Tooltip>
          <Tooltip placement="topLeft" title="Upload">
            <img src="/images/upload.svg" alt="upload-customers" />
          </Tooltip> */}
        </div>
      </div>
      {rolesData?.length ? (
        <CustomTable
          columns={columns}
          data={rolesData}
          showPagination={false}
        />
      ) : !loadingState ? (
        <div className="flex flex-col gap-3 w-full items-center justify-center mt-9">
          <img
            className="w-[40px] h-[40px]"
            src="/images/no-items.svg"
            alt="no data kamco"
          />
          <p className="text-lg text-gray-500 font-medium">
            There are no items in this list
          </p>
        </div>
      ) : (
        ""
      )}
      <CustomModal
        isVisible={openEditRoleModal}
        centered
        width={900}
        showClose={false}
        onClose={() => {
          setOpenEditRoleModal(false);
        }}
        className="edit-modal"
      >
        <div className="flex column align-center justify-center">
          <AddEditRole
            selectedRole={selectedRole}
            edit={true}
            onCancel={() => {
              setOpenEditRoleModal(false);
            }}
            onConfirm={() => {
              getRolesData();
              setOpenEditRoleModal(false);
            }}
          />
        </div>
      </CustomModal>
      <CustomModal
        isVisible={openViewModal}
        centered
        width={900}
        showClose={false}
        onClose={() => {
          setOpenViewModal(false);
        }}
        className="edit-modal"
      >
        <div className="flex column align-center justify-center">
          <ViewRole
            selectedRole={selectedRole}
            onCancel={() => {
              setOpenViewModal(false);
            }}
            onDelete={() => {
              setOpenViewModal(false);
              if (selectedRole.admins?.length) {
                setOpenNotDeleteModal(true);
              } else {
                setOpenDeleteModal(true);
              }
            }}
            onEdit={() => {
              setOpenViewModal(false);
              setOpenEditRoleModal(true);
            }}
          />
        </div>
      </CustomModal>

      <CustomModal
        isVisible={openDeleteModal}
        centered
        width={450}
        onClose={() => {
          setOpenDeleteModal(false);
        }}
        className="delete-modal"
      >
        <DeleteModal
          onCancel={() => setOpenDeleteModal(false)}
          onConfirm={deleteRole}
          text="Delete role!"
          subText={`Are you sure you want to delete this role “${selectedRole?.role}”?`}
        />
      </CustomModal>

      <CustomModal
        isVisible={openNotDeleteModal}
        centered
        width={450}
        onClose={() => {
          setOpenDeleteModal(false);
        }}
        className="delete-modal"
      >
        <DeleteModal
          onCancel={() => setOpenNotDeleteModal(false)}
          onConfirm={() => {
            setOpenNotDeleteModal(false);
            setOpenViewModal(true);
          }}
          notDelete={true}
          text="Delete role!"
          subText={`You can’t delete the “${selectedRole?.role}” role, you need to remove assigned users first`}
        />
      </CustomModal>
    </div>
  );
};

export default RolesList;
